import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ModalComponent from '../../../shared-components/ModalComponent/ModalComponent';
import './EscapeHatch.less';
import CancelUrl, { COMPONENT_STYLE } from '../CancelUrl/CancelUrl';
import { hideEscapeHatch } from './EscapeHatchActions';
import Button, { BUTTON_STYLE } from '../../../shared-components/Button/Button';

export class EscapeHatch extends Component {
    static propTypes = {
        onContinue: PropTypes.func.isRequired,

        // Passed in props
        headerText: PropTypes.string.isRequired,
        bodyText1: PropTypes.string.isRequired,
        bodyText2: PropTypes.string,
        continueText: PropTypes.string.isRequired,
        cancelText: PropTypes.string.isRequired
    };

    handleContinue = () => {
        this.props.onContinue();
    };

    render() {
        const {
            headerText, bodyText1, bodyText2, continueText
        } = this.props;

        return (
            <ModalComponent allowEscKey={false} showUnderlay={false}>
                <div id="escapeHatch" className="vertical-middle text-center">
                    <div className="escapeHatchContainer">
                        <div className="escapeHatchHeader">
                            <div className="ppcredit-logo show-for-mobile" />
                            <h3 className="vx_text-3_lighter text-left">{headerText}</h3>
                        </div>
                        <p className="escapeHatchMessageContent">{bodyText1}</p>
                        <p className="escapeHatchMessageContent">
                            <span>{bodyText2}</span>
                        </p>
                        <div className="escape-hatch-buttons">
                            <div className="escape-hatch-button">
                                <CancelUrl
                                    componentType={COMPONENT_STYLE.ESCAPE_HATCH_BUTTON}
                                />
                            </div>
                            <div className="escape-hatch-button">
                                <Button
                                    data-automation-id="continue"
                                    id="bmlContinueApply"
                                    btnStyle={BUTTON_STYLE.PP_PRIMARY}
                                    data-initialfocus
                                    fullWidth={true}
                                    onClick={this.handleContinue}
                                >
                                    {continueText}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalComponent>
        );
    }
}

export const mapDispatchToProps = dispatch => ({
    onContinue() {
        dispatch(hideEscapeHatch());
    }
});

export default connect(null, mapDispatchToProps)(EscapeHatch);
